import "./styles.css";
import "./background-canvas.js";
import Clarity from '@microsoft/clarity';

const CLARITY_PROJECT_ID = import.meta.env.VITE_CLARITY_PROJECT_ID;
if (CLARITY_PROJECT_ID) {
  Clarity.init(CLARITY_PROJECT_ID);
}

// Initialize Google Analytics if ID is configured
const GA_ID = import.meta.env.VITE_GA_ID;
if (GA_ID) {
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", GA_ID);
}

document.addEventListener("DOMContentLoaded", () => {
  const navToggle = document.querySelector(".nav-toggle");
  const primaryNav = document.getElementById("primary-nav");
  const form = document.querySelector(".contact-form");
  const formNote = form?.querySelector(".form-note");
  const currentYearEl = document.getElementById("current-year");

  const WEB3_ENDPOINT = "https://api.web3forms.com/submit";
  const WEB3_ACCESS_KEY = "325ef371-4c61-4f0e-b851-7f06fa103b60";

  if (currentYearEl) {
    currentYearEl.textContent = new Date().getFullYear();
  }

  const closeNav = () => {
    if (!navToggle || !primaryNav) return;
    navToggle.setAttribute("aria-expanded", "false");
    primaryNav.classList.remove("open");
    document.body.style.overflow = "auto";
  };

  if (navToggle && primaryNav) {
    navToggle.addEventListener("click", () => {
      const isExpanded = navToggle.getAttribute("aria-expanded") === "true";
      navToggle.setAttribute("aria-expanded", String(!isExpanded));
      primaryNav.classList.toggle("open", !isExpanded);
      // Prevent scrolling when navigation is open
      document.body.style.overflow = isExpanded ? "auto" : "hidden";
    });

    primaryNav.querySelectorAll("a").forEach((link) => {
      link.addEventListener("click", () => {
        closeNav();
      });
    });
  }

  const setFormNote = (message, type = "info") => {
    if (!formNote) return;
    formNote.textContent = message;
    formNote.dataset.status = type;
  };

  // Check for success status in URL
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('status') === 'success') {
    setFormNote("Thanks! Your message has been sent successfully.", "success");
    // Clean up URL without refreshing
    window.history.replaceState({}, document.title, window.location.pathname);
  }

  if (form) {
    form.addEventListener("submit", () => {
      const submitButton = form.querySelector("button[type='submit']");
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = "Sending...";
      }
    });
  }

});



